export const DATAVISOR_URL_PROD = 'https://portal-prod.marqetariskcontroldecisioning.com/v3';
export const DATAVISOR_URL_SANDBOX = 'https://portal-sbx.marqetariskcontroldecisioning.com/v3/';
export const FEATURESPACE_URL = 'https://rpg-featurespace.us-east-1.mq00-prod.aws.marqeta.io';
